// extracted by mini-css-extract-plugin
module.exports = {"container":"back-button__container___2fKrs"};